import React from 'react';
import PropTypes from 'prop-types';
import createWidget from '../createWidget';
import { PieChartComponent } from '../../chart-components/PieChartComponent_v2.jsx';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

/**
 * DonutChartInner - Inner component for the donut chart widget
 * Renders the actual pie/donut chart visualization
 */
const DonutChartInner = ({ data, config }) => (
  <PieChartComponent
    data={data.data}
    title={config.title}
    subtitle={config.subtitle}
    name={config.nameKey || 'name'}
    value={config.valueKey || 'value'}
    format={config.format}
  />
);

DonutChartInner.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.array
  }).isRequired,
  config: PropTypes.shape({
    title: PropTypes.string.isRequired,
    nameKey: PropTypes.string,
    valueKey: PropTypes.string,
    subtitle: PropTypes.string,
    format: PropTypes.oneOf(['currency', 'percentage', 'decimal'])
  }).isRequired
};

/**
 * DonutChartWidget - Created using the widget factory
 * Displays data in a donut/pie chart format
 */
const DonutChartWidget = createWidget('donutchart', DonutChartInner, {
  includeDates: false,
  emptyState: {
    title: 'No data available',
    description: 'Try adjusting your filters or date range',
    icon: icon({ name: 'chart-pie', family: 'sharp', style: 'light' })
  }
});

export default DonutChartWidget;
